import { createNamespacedHelpers, type Action } from 'vuex';
import type { FederatedInvite } from '@/types/models/federatedInvites';
import api from './api';

export const { mapState, mapActions, mapGetters, mapMutations } =
  createNamespacedHelpers('federatedInvites');

const initialState = () => ({
  byID: {}, // map of invite ID to invite object
  allIDs: [], // invite IDs, ordered from newest sent to oldest sent
});

type FederatedInviteState = {
  byID: Record<string, FederatedInvite>;
  allIDs: string[];
};

const fetchInvites: Action<FederatedInvite, any> = async ({ commit }) => {
  const res = await api.fetchInvites();
  commit('SET_ALL_INVITES', res.data);
};

const sendInvite: Action<FederatedInvite, any> = async (
  { commit },
  { organisationName, contactEmail }: { organisationName: string; contactEmail: string },
) => {
  const res = await api.sendInvite(organisationName, contactEmail);
  commit('ADD_INVITE', res.data);
};

const cancelInvite: Action<FederatedInvite, any> = async ({ commit }, id: string) => {
  const res = await api.cancelInvite(id);
  commit('SET_INVITE', res.data);
};

const actions = {
  fetchInvites,
  sendInvite,
  cancelInvite,
};

const mutations = {
  SET_ALL_INVITES(state: FederatedInviteState, invites: FederatedInvite[]) {
    state.byID = invites.reduce((obj: Record<string, FederatedInvite>, invite: FederatedInvite) => {
      obj[invite.id] = invite;
      return obj;
    }, {});

    state.allIDs = invites.map((invite) => invite.id);
  },
  ADD_INVITE(state: FederatedInviteState, invite: FederatedInvite) {
    state.byID[invite.id] = invite;
    state.allIDs.push(invite.id);
  },
  SET_INVITE(state: FederatedInviteState, invite: FederatedInvite) {
    state.byID[invite.id] = invite;
  },
};

// TODO: replace with composables (1 day)
export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
};
